import ProfileNavbarMenuItem from './ProfileNavbarMenuItem'
import { navbarExtraServices, navbarMainTabs } from 'src/lib'
import { useMainState } from 'src/store'
import { useIsMobile } from 'src/utils'
import { Button } from 'src/components'
import { t } from 'i18next'
import Divider from './Divider'

const ProfileNavbarMenu = () => {
  const isMobile = useIsMobile()
  const { firstName, lastName, userId } = useMainState((state) => state.user)
  const classes = [
    isMobile
      ? 'w-full h-full gap-[50px] pb-[30px]'
      : 'w-[297px] h-fit bg-dark-gray gap-[10px] pb-[10px]',
    'flex-column',
  ]

  const handleLogout = () => {
    //to do handle logout when be is ready
  }

  return (
    <div className={classes.join(' ')}>
      <div className='w-full flex-column items-center mt-[10px] medium-3'>
        <div>{`${firstName} ${lastName}`}</div>
      </div>
      <div className='w-full h-full flex-column overflow-x-hidden overflow-y-auto'>
        {navbarMainTabs.map(ProfileNavbarMenuItem)}
        {!userId && (
          <>
            <Divider />
            {navbarExtraServices.map(ProfileNavbarMenuItem)}
          </>
        )}
      </div>
      {userId && (
        <Button className='mx-[10px]' onClick={handleLogout}>
          {t('global.logout')}
        </Button>
      )}
    </div>
  )
}

export default ProfileNavbarMenu
